import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Toast } from 'vant';
import {
  getResult,
  getRiskResult,
  getUserNameByPhone
} from '../data-source/api';
import native from '@/utils/native';
import qs from 'qs';
import { useRoute } from 'vue-router';
import { FaceAuthType } from '../types';


const __default__ = {
  name: 'face-auth-result'
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const bizId = (qs.parse(window.location.search.slice(1))['biz_id'] ||
  '') as string;

let info: any = {
  phone: Reflect.get(route.query as any, 'phone')
};

const from = Reflect.get(route.query, 'from') as FaceAuthType;
let req = getResult;
if ([FaceAuthType.LOGIN, FaceAuthType.WITHDRAW].includes(from)) {
  info = {
    phone: Reflect.get(route.query, 'phone') as string,
    from: Reflect.get(route.query, 'from') as string
  };
  if (Reflect.get(route.query, 'extendInfo')) {
    info.extendInfo = Reflect.get(route.query, 'extendInfo');
  }
  req = getRiskResult;
}

const errCallback = async () => {
  const { data: tmName } = await getUserNameByPhone(info);
  native.method.faceAuthFile({ tmName, ...info }); // 失败回调
};

if (!bizId) {
  errCallback();
} else {
  let count = 0;

  Toast.loading({ message: '加载中', duration: 0 });
  const check = () => {
    req({ bizId: decodeURIComponent(bizId), ...info })
      .then(res => {
        count++;
        switch (res.data.authStatus) {
          // 认证通过
          case 3:
            try {
              if (from === FaceAuthType.LOGIN) {
                native.method.faceAuthLoginComplete({
                  ...res.data,
                  type: FaceAuthType.LOGIN
                });
              } else if (from === FaceAuthType.WITHDRAW) {
                native.method.faceAuthWithdrawComplete({
                  ...res.data,
                  type: FaceAuthType.WITHDRAW
                });
              } else {
                native.method.faceAuthComplete({
                  token: res.data.token
                });
              }
            } catch (error) {
              console.warn(error);
            }
            break;
          // 认证中
          case 2:
            if (count <= 5) {
              setTimeout(check, 1000);
            } else {
              errCallback();
            }
            break;
          default:
            errCallback();
        }
      })
      .catch(() => {
        errCallback();
      });
  };
  check();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})